import { isString } from './isString.js';
import { typeOf } from './typeOf.js';

/**
 * @example: isElement('div', document.createElement('div')); // true
 * @param {string} element
 * @param {*} value
 * @returns {boolean}
 */
function isElement(element, value) {
    var type = typeOf(value);
    if (isString(type)) {
        return type.toLowerCase() === 'html' + String(element).toLowerCase() + 'element';
    }
    return false;
}

export { isElement };
